<!--
  - Copyright Huesik (c) 2019.
  -->
<!-- eslint-disable -->
<template>
  <div class="suggestion-kosiwons-wrapper">
    <h5>{{title}}</h5>
    <agile
      v-if="packageList.length > 0"
      :dots="false"
      :slides-to-show="slideToShow ? slideToShow : viewType === 'grid' ? 1 : 4"
      :navButtons="navButtons"
      ref="packageListView"
      @afterChange="reloadData"
      timing="ease-in-out"
      :speed="300">
      <div class="kosiwons-item-wrapper" v-for="(packageSemiList, index) in packageList" :key="`__PACKAGE_WRAPPER_${index}`" :class="{grid: viewType === 'grid', row: viewType === 'row'}">
        <div v-if="packageSemiList.hasOwnProperty('length')"  class="kosiwons-grid-container">
          <package-list-item
            v-for="(packageItem, index) in packageSemiList"
            :kosiwon="packageItem"
            :key="`__PACKAGE_ITEM__${index}`"
            :viewType="viewType"
            @click.native="moveToDetail(packageItem.pk, packageItem)"
          />
        </div>
        <div v-else class="kosiwons-row-container">
          <package-list-item
            :kosiwon="packageSemiList"
            :key="`__PACKAGE_ITEM__${index}`"
            :viewType="viewType"
            @click.native="moveToDetail(packageSemiList.pk, packageSemiList)"
          />
        </div>
      </div>
      <template slot="prevButton" v-if="$mq !== 'sm'">
        <img src="../../assets/images/prev-grey.png" />
      </template>
      <template slot="nextButton" v-if="$mq !== 'sm'">
        <img src="../../assets/images/next-grey.png" />
      </template>
    </agile>
    <!--<vue-simple-spinner size="big" v-if="packageList.length === 0" line-fg-color="#3c6bbb" :style="{padding: '5rem'}"/>-->
  </div>
</template>

<script>
  import PackageListItem from './PackageListItem'
  import {VueAgile} from 'vue-agile'
  import VueSimpleSpinner from 'vue-simple-spinner'
  import DynamicNavigator from '../../core/modules/DynamicNavigator'


  export default {
    name: 'PackageList',
    props: {
      viewType: {
        type: String,
        default: 'grid'
      },
      title: {
        type: String,
        default: '추천 고시원'
      },
      latlng: {
        type: Object,
        default: () => {}
      },
      slideToShow: Number,
      itemCount: Number,
      navButtons: {
        type: Boolean,
        default: true
      }
    },
    components: {
      PackageListItem,
      agile: VueAgile,

    },
    data () {
      return {
        packageList: []
      }
    },
    watch: {
    },
    computed: {
    },
    methods: {
      async fetchList () {
        try {
          let url = '/kosiwons/suggestion'
          if (this.latlng && this.latlng.lat && this.latlng.lng) {
            url = `${url}?lat=${this.latlng.lat}&lng=${this.latlng.lng}`
          }
          const _packageListData = await this.axios.get(url)
          const packageList = _packageListData.data.result
          // this.packageList = packageList.data.result
          const tempLength = Math.ceil(packageList.length / this.itemCount)
          for ( let i = 0; i < tempLength; i ++ ) {
            this.packageList.push(packageList.slice((i * this.itemCount), (i+1)*this.itemCount))
          }
          if (this.$refs.packageListView) {
            this.$refs.packageListView.reload()
          }
          this.$store.dispatch('setNetworkIndicator', false)
        } catch (error) {
          console.error(error)
        }
      },
      reloadData () {
        // this.$refs.packageListView.reload()
      },
      moveToDetail (pk, kosiwon) {

        if(window.gtag) {
          window.gtag('event', '버튼 클릭', {
            event_category: '추천 고시원',
            event_label: `${kosiwon.name} ${kosiwon.branch}`
          })
        }

        let routeData = this.$router.resolve(`/detail/${pk}`)
        DynamicNavigator.getInstance().moveToDetail(routeData.href, this.$router)
      }
    },
    mounted () {
      this.fetchList()
    }
  }
</script>

<style scoped lang="less">
  h5 {
    text-align: left;
    font-size: 2rem;
    font-weight: bold;
    padding: 4rem 0 1rem 0;
  }
  .kosiwons-item-wrapper {
    .kosiwons-grid-container {
      display: flex;
      flex-flow: row wrap;
      align-content: center;
      justify-content: space-between;
      height: 100%;
      width: 100%;
    }
    .kosiwons-row-container {
      width: 100%;
      margin: 0 2rem;
    }
  }
  .kosiwons-container{
    width: 100%;
    max-width: 27rem;
  }
</style>
<style lang="less">
  .suggestion-kosiwons-wrapper {
    .agile__actions {
      > button {
        background: transparent;
        &.agile__nav-button--next {
          position: absolute;
          top: 50%;
          right: 0;
          margin-right: -2.5rem;
        }

        &.agile__nav-button--prev {
          position: absolute;
          top: 50%;
          left: 0;
          margin-left: -2.5rem;
        }
      }
    }
  }
</style>

<style scoped lang="less" >
  @import "../../assets/css/palette";
  /* Medium devices (landscape tablets, 768px and up) */
  @media screen and (max-width: 768px) {
    h5 {
      text-align: left;
      font-size: 2rem;
      font-weight: bold;
      padding-top: 2rem;
    }
    .kosiwons-item-wrapper {
      .kosiwons-grid-container {
        flex-flow: inherit;
        justify-content: space-between;
      }
    }
  }
</style>

